module.exports = __webpack_public_path__ + "img/clue06_bg.590dc666.png";